import { watch, reactive } from "vue";
import { v4 as uuidv4 } from "uuid";
import { ElMessage } from "element-plus";
import _ from "lodash";

import {
  chatConversation,
  chatDelConversation,
  postChatConversation,
} from "@/api/chatApi.js";
import { addLoginEvent } from "../useLogin/useLogin";
import { getStorage } from "@/utils/storage";
// #ifdef H5
// #endif
import { openCustomPopup } from "@/components/custom-popup/use/customPopup";

const useDialogue = (options = {}) => {
  // 查询会话类型
  // addNew  是否添加新对话
  const { type: queryType, excludeType, addNew, isCache = true } = options;
  // 对话列表数据
  const dialogueList = reactive([]);
  let cacheList = [];
  let cacheSessionId = "";
  // isGetting  正在获取对话列表
  // sessionId  当前对话的sessionId
  const dialogueStatus = reactive({
    bgc: "blue", // 背景颜色
    isGetting: false,
    sessionId: "",
  });
  let last_page = 1;
  const listQuery = {
    page: 1,
    page_size: 20,
    keywords: "",
  };
  // 添加新对话
  const addDialogue = (isAudioText = false) => {
    let index = dialogueList.findIndex((item) => !item.is_top);
    if (index === -1) {
      index = dialogueList.length;
    }
    const sessionId = uuidv4();

    if (dialogueList[index]?.isNew) {
      if (dialogueStatus.sessionId === dialogueList[index].session_id) {
        // 如果是工具箱-实时会议记录，那么不显示
        if (!isAudioText) {
          ElMessage.warning("当前已是最新对话，请勿重复操作");
        }
        return false;
      }
      dialogueStatus.sessionId = dialogueList[index].session_id;
      cacheSessionId = dialogueStatus.sessionId;
      return true;
    }
    dialogueList.splice(index, 0, {
      title: "新建聊天对话",
      session_id: sessionId,
      isNew: true,
    });
    dialogueStatus.sessionId = sessionId;
    cacheSessionId = dialogueStatus.sessionId;
    return true;
  };
  const setSessionId = (sessionId) => {
    dialogueStatus.sessionId = sessionId;
    cacheSessionId = sessionId;
  };
  // 获取对话数据
  const getDialogueList = _.throttle(async (opts) => {
    const inSearch = opts?.inSearch;
    dialogueStatus.isGetting = true;
    try {
      const params = {
        type: queryType,
        exclude_type: excludeType,
        ...listQuery,
      };
      // console.log("params", params);
      const res = await chatConversation(params);

      last_page = res.last_page || 1;
      const list = res.list || [];
      if (listQuery.page === 1) {
        dialogueList.splice(0, dialogueList.length, ...list);
      } else {
        dialogueList.push(...list);
      }
      console.log("dialogueList", dialogueList);
    } catch (e) {
      console.log("getDialogueList fail");
      console.log(e);
    } finally {
      dialogueStatus.isGetting = false;
      if (inSearch) {
        // eslint-disable-next-line no-unsafe-finally
        return;
      }
      if (listQuery.page === 1) {
        if (
          opts.sessionId &&
          dialogueList.some((item) => item.session_id === opts.sessionId)
        ) {
          dialogueStatus.sessionId = opts.sessionId;
          cacheSessionId = dialogueStatus.sessionId;
        } else if (!addNew && !listQuery.keywords) {
          dialogueStatus.sessionId = dialogueList[0]?.session_id;
          cacheSessionId = dialogueStatus.sessionId;
        } else if (!dialogueStatus.sessionId && !opts.sessionId) {
          addDialogue();
        }
      }
    }
  }, 1000);
  const reGetDialogueList = ({ inSearch = false }) => {
    listQuery.page = 1;
    getDialogueList({ inSearch });
  };
  // 获取下一页数据
  const nextDialoguePage = () => {
    if (listQuery.page + 1 > last_page) return;
    listQuery.page++;
    getDialogueList();
  };
  // 删除对话
  const deleteDialogue = async (
    index,
    back = false,
    delSessionId,
    options = {}
  ) => {
    const title = options?.title || "确定要删除该对话吗？";
    const content =
      options?.content || "删除后该对话记录无法恢复和找回，请谨慎操作";
    const successText = options?.successText || "删除对话成功";
    return new Promise((resolve) => {
      openCustomPopup({
        title,
        content,
        confirmFun: async () => {
          const sessionId = delSessionId || dialogueList[index].session_id;
          try {
            const params = {
              session_id: sessionId,
            };
            await chatDelConversation(params);
            dialogueList.splice(index, 1);
            if (sessionId === dialogueStatus.sessionId) {
              dialogueStatus.sessionId = dialogueList[0]?.session_id;
            }
            reGetDialogueList();
            resolve();
            // if (back) {
            //   uni.switchTab({ url: "/pages/index/index" });
            // }
          } catch (e) {
            resolve();
          } finally {
            ElMessage.success(successText);
          }
        },
      });
    });
  };
  const deleteSelectDialogue = async (sessionIds, back = false) =>
    new Promise((resolve) => {
      openCustomPopup({
        title: `确认删除这 ${sessionIds.length} 条对话记录吗？`,
        content: "删除后对话记录无法恢复和找回，请谨慎操作",
        confirmFun: async () => {
          try {
            await chatDelConversation({ sessionIds });
            setTimeout(() => {
              reGetDialogueList({ inSearch: true });
            });
            resolve();
            if (back) {
              // uni.switchTab({ url: "/pages/index/index" });
            }
          } catch (e) {
            resolve();
          } finally {
            ElMessage.success("删除对话成功");
          }
        },
      });
    });
  // 清空写作里选中的
  const deleteSelectDialogueInWrite = async (sessionIds) =>
    new Promise((resolve) => {
      // openCustomPopup({
      //   title: `清空当前生成写作列表`,
      //   content: "是否删除当前列表的生成记录？请谨慎操作。",
      //   confirmFun: async () => {
      //     try {
      //       await chatDelConversation({ sessionIds });
      //       setTimeout(async () => {
      //         await reGetDialogueList({ inSearch: true });
      //         setTimeout(() => {
      //           addDialogue();
      //         }, 1000);
      //       });
      //       resolve();
      //     } catch (e) {
      //       resolve();
      //     } finally {
      //       Message.success("删除记录成功");
      //     }
      //   },
      // });
    });

  // 删除写作里的对话
  const deleteDialogueInWrite = async (index, delSessionId, options = {}) => {
    const title = options?.title || "确定要删除该对话吗？";
    const content =
      options?.content || "删除后该对话记录无法恢复和找回，请谨慎操作";
    const successText = options?.successText || "删除对话成功";
    return new Promise((resolve) => {
      // openCustomPopup({
      //   title,
      //   content,
      //   confirmFun: async () => {
      //     const sessionId = delSessionId || dialogueList[index].session_id;
      //     try {
      //       const params = {
      //         session_id: sessionId,
      //       };
      //       await chatDelConversation(params);
      //       dialogueList.splice(index, 1);
      //       if (sessionId === dialogueStatus.sessionId) {
      //         dialogueStatus.sessionId = dialogueList[0]?.session_id;
      //       }
      //
      //       if (dialogueList.length == 0) {
      //         setTimeout(() => {
      //           addDialogue();
      //         }, 1000);
      //       }
      //
      //       reGetDialogueList();
      //
      //       resolve();
      //     } catch (e) {
      //       resolve();
      //     } finally {
      //       Message.success(successText);
      //     }
      //   },
      // });
    });
  };
  // 清空对话列表
  const clearDialogueList = () => {
    openCustomPopup({
      title: "确定要清空该对话消息吗？",
      content: "清空后该对话消息无法恢复和找回，请谨慎操作",
      confirmFun: async () => {
        // const params = {
        //   is_all: 1,
        // };
        // await chatDelConversation(params);
        dialogueList.splice(0, dialogueList.length);
        listQuery.page = 1;
        last_page = 1;
      },
    });
  };

  // 重命名
  const renameDialogue = async (index, title) => {
    try {
      await postChatConversation({
        session_id: dialogueList[index].session_id,
        title,
      });
      dialogueList[index].title = title;
    } catch {
      //
    }
  };

  //  置顶
  const postTopDialogue = (index) => {
    postChatConversation({
      session_id: dialogueList[index].session_id,
      is_top: !dialogueList[index].is_top,
    }).then(() => {
      ElMessage.success(
        `${dialogueList[index].is_top ? "已取消置顶" : "置顶成功"}`
      );
      reGetDialogueList({ inSearch: true });
    });
  };

  // 初始化
  const init = (opts) => {
    console.log("initList");
    clearLocalDialogueList();
    const { inSearch, searchKey, sessionId } = opts || {};
    if (!listQuery.keywords && searchKey) {
      cacheList = JSON.parse(JSON.stringify(dialogueList));
      cacheSessionId = dialogueStatus.sessionId;
    }
    if (listQuery.keywords && !searchKey) {
      dialogueList.splice(0, dialogueList.length, ...cacheList);
      dialogueStatus.sessionId = cacheSessionId;
      return;
    }
    dialogueList.splice(0, dialogueList.length);
    listQuery.page = 1;
    last_page = 1;
    listQuery.keywords = searchKey || "";
    if (!getStorage("token")) return;
    getDialogueList({ inSearch, sessionId });
    dialogueStatus.sessionId = "";
  };
  // 如果登录了之后再执行 初始化数据
  addLoginEvent("login", {
    key: `initDialogue${queryType}`,
    handler: () => {
      // init();
    },
    cache: isCache,
  });

  const clearLocalDialogueList = () => {
    dialogueList.splice(0, dialogueList.length);
    listQuery.page = 1;
    last_page = 1;
  };

  return {
    dialogueList,
    dialogueStatus,
    init,
    addDialogue,
    setSessionId,
    nextDialoguePage,
    deleteDialogue,
    deleteDialogueInWrite,
    deleteSelectDialogue,
    deleteSelectDialogueInWrite,
    clearDialogueList,
    renameDialogue,
    postTopDialogue,
    clearLocalDialogueList,
    reGetDialogueList,
  };
};

export default useDialogue;
